import {Reducer} from "redux";
import {PledgerAction} from "@pledger/frontend-commons";

import {CreateSouscriptionActions} from "../CreateSouscriptionActions";
import {CreateCGPSouscriptionActions} from "./CreateCGPSouscriptionActions";


const warrantyPartnerId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateCGPSouscriptionActions.CREATE_CGP_SOUSCRIPTION_SELECT_WARRANTY_PARTNER_ACTION.type:
            return action.payload.warrantyPartnerId;
        default:
            return state;
    }
};

const accountTypeId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateCGPSouscriptionActions.CREATE_CGP_SOUSCRIPTION_SELECT_ACCOUNT_TYPE_ACTION.type:
            return action.payload.accountTypeId;
        default:
            return state;
    }
};

const accountNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_CGP_ACCOUNT_NUMBER_ACTION.type:
            return action.payload.accountNumber;

        default:
            return state;
    }
};

const accountLabel = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_CGP_ACCOUNT_LABEL_ACTION.type:
            return action.payload.accountLabel;

        default:
            return state;
    }
};




export interface SouscriptionCGPState {
    warrantyPartnerId : string;
    accountTypeId : string;
    accountNumber:string;
    accountLabel:string;
};

export const souscriptionCGPReducers : Reducer = (state={}, action)=> {
    return {
        warrantyPartnerId: warrantyPartnerId(state.warrantyPartnerId, action),
        accountTypeId: accountTypeId(state.accountTypeId, action),
        accountNumber: accountNumber(state.accountNumber, action),
        accountLabel: accountLabel(state.accountLabel, action),
    }
}
